import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useCreateScheduleRun = () => {
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);
  const {
    isLoading, isError, isSuccess, mutate, mutateAsync, reset,
  } = useMutation(
    ['update-flow-scheduled-run-status', orgId],
    ({ crId, crFlowId, payload }) => (
      axiosInstance.post(flow(orgId).createScheduleRun(crId, crFlowId), payload)
    ),
    {
      onSuccess: () => {
        dispatch(showAlert({ message: 'Flow Schedule Run has been created.', type: 'success' }));
      },
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
    },
  );
  return {
    isLoading, isError, isSuccess, mutate, mutateAsync, reset,
  };
};
